import React from 'react';
import { HiOutlineCloudArrowUp, HiFunnel, HiOutlineBookOpen } from "react-icons/hi2";
import ResourceCard from '../components/ResourceCard/ResourceCard';
import ResourceCardSkeleton from '../components/ResourceCard/ResourceCardSkeleton';
import useResourcesFacade from '../facades/useResourcesFacade';
import LibraryPageBanner from '../components/ProductionBanners/LibraryPageBanner';

const Resources = () => {
  const {
    loading,
    filteredResources,
    selectedBranch,
    setSelectedBranch,
    branches,
    navigate,
  } = useResourcesFacade();

  const isDevelopment = process.env.NODE_ENV === 'development';
  
  if(!isDevelopment) {
    return <LibraryPageBanner/>
  }

  return (
    <div className="max-w-7xl mx-auto px-4 pb-20">
      {/* 1. Impact Header */}
      <div className="relative overflow-hidden bg-slate-900 rounded-[3rem] p-8 md:p-12 mt-8 mb-12 text-white">
        <div className="relative z-10 flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="text-center md:text-left space-y-4">
            <div className="inline-flex items-center gap-2 bg-blue-500/20 text-blue-400 px-4 py-1.5 rounded-full text-xs font-black uppercase tracking-widest">
              <HiOutlineBookOpen size={16} />
              Community Library
            </div>
            <h1 className="text-3xl md:text-5xl font-black tracking-tighter">
              Learn together, <br />
              <span className="text-blue-400 font-medium italic">grow together.</span>
            </h1>
            <p className="text-slate-400 max-w-md font-medium text-sm leading-relaxed">
              Don't let your notes gather dust. Share your study materials, previous papers, and guides to help fellow students ace their exams.
            </p>
          </div>

          <button
            onClick={() => navigate('/uploadResources')}
            className="group flex items-center gap-3 bg-white text-slate-900 px-8 py-4 rounded-2xl font-black text-sm hover:bg-blue-50 transition-all active:scale-95 shadow-xl shadow-white/5"
          >
            <HiOutlineCloudArrowUp size={20} className="group-hover:-translate-y-1 transition-transform" />
            Contribute Material
          </button>
        </div>
        <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 bg-blue-600/20 rounded-full blur-3xl"></div>
      </div>

      {/* 2. Filter Bar */}
      <div className="flex flex-col md:flex-row items-center justify-between mb-8 gap-4 px-2">
        <h2 className="text-xl font-black text-slate-900 uppercase tracking-tighter flex items-center gap-2">
          <HiFunnel className="text-blue-600" size={20} />
          Browse by Branch
        </h2>

        <div className="flex flex-wrap justify-center gap-2">
          <button
            onClick={() => setSelectedBranch('')}
            className={`px-5 py-2.5 rounded-xl text-xs font-black transition-all ${!selectedBranch ? 'bg-slate-900 text-white shadow-lg' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'}`}
          >
            ALL
          </button>
          {branches.map(branch => (
            <button
              key={branch}
              onClick={() => setSelectedBranch(branch)}
              className={`px-5 py-2.5 rounded-xl text-xs font-black transition-all ${selectedBranch === branch ? 'bg-blue-600 text-white shadow-lg shadow-blue-100' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'}`}
            >
              {branch.split(' ')[0]}
            </button>
          ))}
        </div>
      </div>

      {/* 3. Resources Grid */}
      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 py-10">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <ResourceCardSkeleton key={i} />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredResources && filteredResources.map(resource => (
            <ResourceCard key={resource._id} resource={resource} />
          ))}
        </div>
      )}

      {!loading && filteredResources?.length === 0 && (
        <div className="text-center py-20 bg-slate-50 rounded-[3rem] border-2 border-dashed border-slate-200">
          <p className="text-slate-400 font-bold uppercase tracking-widest text-xs">No resources found for this branch yet.</p>
        </div>
      )}
    </div>
  );
};

export default Resources;